module.exports = __webpack_public_path__ + "static/wtw-white-logo-2ec3d5f0ff431abc37a7cbfdd3161168.svg";